/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Reality_MoravaInputs */

const cs_enum_reality_morava = /** @type {(inputs: Enum_Reality_MoravaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality Morava`)
};

const en_enum_reality_morava = /** @type {(inputs: Enum_Reality_MoravaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality Morava`)
};

/**
* | output |
* | --- |
* | "Reality Morava" |
*
* @param {Enum_Reality_MoravaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reality_morava = /** @type {((inputs?: Enum_Reality_MoravaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Reality_MoravaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reality_morava(inputs)
	return cs_enum_reality_morava(inputs)
});